
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

    @Component
    export default class KeyboardInput extends Vue {
        list = [] as string[];
        checkList = [];
        input = "";  //自定义原因
        other = false;
        @Prop() private textList!: [];
        created(){
            if(this.textList){
                this.list = this.textList;
            }else{
                this.list = [
                    '不通过原因1',
                    '不通过原因2',
                    '不通过原因3',
                    '不通过原因4',
                    '不通过原因5',
                ];
            }
        }
        getText(){
            let text = this.checkList.join(";");
            if(this.other){
                if(this.checkList && this.checkList.length > 0){
                    text += ";";
                }
                text += this.input;
            }
            return text;
        }
    }
